export default __webpack_public_path__ + "static/media/908.69d832fb.png";